// extracted by mini-css-extract-plugin
export default {"RulesetActionMenuLinkItem":"RulesetActionMenu-module__RulesetActionMenuLinkItem__L_oKqL8"};